import fr from 'facet-rest';
import RichTextDisplayOverride from 'Components/UI/Overrides/RichTextDisplay';

export const meetingAgendaHistoryTitleGenerator = () => resource => resource.attr('subject');

export const MeetingAgendaHistoryOverride = fr.metaOverride()
  .override({ readonly: true }, { hidden: true })
  .nameOverride('subject', { ordinal: 1, hidden: false })
  .nameOverride('content', {
    ordinal: 2,
    hidden: false,
    readonly: false,
    _component: () => RichTextDisplayOverride,
  })
  .nameOverride('updatedAt', { _titleGenerator: meetingAgendaHistoryTitleGenerator, hidden: true });
